<template>
  <div id="productResults">
    <template>

      <b-button @click="exportToExcel(productResultItems, visibleFields, 'Product Results')" v-if="productResultItems.length">
        Download Excel
      </b-button>

      <div class="my-5">

        <!-- Sticky Header Table -->
        <b-table
            class="results-table header-only"
            v-if="productResultItems.length"
            :fields="visibleFields"
            :items="productResultItems"
            bordered
            responsive="true"
            striped
            sort-by="carrier"
            sort-by-formatted
            table-class="word-nowrap"
            :style="{ maxHeight: 'fit-content' }"
            @head-clicked="onHeaderClicked"
        >


          <template #cell(carrier)="data">
            <span v-html="getCarrierNameByID(data.item.carrier)"></span>
          </template>


          <template #cell(ABRLinks)="data">
            <ul v-if="data.item.ABRLinks" class="list-unstyled m-0">
              <template v-for="(abr, i) of data.item.ABRLinks">
                <li v-if="abr.id" :key="i">
                  <b-link @click="showABRModal(abr.id)" target="_blank"><span v-html="abr.title"></span></b-link>
                </li>
              </template>
            </ul>
          </template>

          <template #cell(ProdIssueAge)="data">
            {{ data.item.ProdIssueAgeMin }} - {{data.item.ProdIssueAgeMax}}, {{data.item.ProdIssueAgeType}}
          </template>

          <template #cell(ProdDBOptions)="data">
            <div>
              <ul v-if="data.item.ProdDBOptions" class="list-unstyled m-0">
                <template v-for="(option, i) of data.item.ProdDBOptions">
                  <li v-if="option" :key="i">
                    {{ option }}
                  </li>
                </template>
              </ul>
            </div>
          </template>

          <template #cell(ProdDuration)="data">
            <span >{{data.item.ProdDuration.join(", ")}}</span>
          </template>

          <template #cell(ProdRidersOptions)="data">
            <span >{{data.item.ProdRidersOptions.join(", ")}}</span>
          </template>

          <template #cell(ProdDBMin)="data">
            <span >${{Number(data.item.ProdDBMin).toLocaleString()}}</span>
          </template>

          <template #cell(ProdCapParRates)="data">
            <ul v-if="data.item.ProdCapParRates" class="list-unstyled m-0">
              <template v-for="(link, i) of data.item.ProdCapParRates">
                <li v-if="link.ProdURL.url" :key="i">
                  <b-link :href="link.ProdURL.url" target="_blank">
                    {{ (link.ProdURL.title ? link.ProdURL.title : link.ProdURL.url) }}
                  </b-link>
                </li>
              </template>
            </ul>
          </template>

          <template #cell(ProdInfoLinks)="data">
            <ul v-if="data.item.ProdInfoLinks" class="list-unstyled m-0">
              <template v-for="(link, i) of data.item.ProdInfoLinks">
                <li v-if="link.ProdURL.url" :key="i">
                  <b-link :href="link.ProdURL.url" target="_blank">
                    {{ (link.ProdURL.title ? link.ProdURL.title : link.ProdURL.url) }}
                  </b-link>
                </li>
              </template>
            </ul>
          </template>

        </b-table>

        <!-- Content Table -->
        <b-table
            class="results-table content-only"
            v-if="productResultItems.length"
            :fields="visibleFields"
            :items="productResultItems"
            bordered
            responsive="true"
            :sticky-header="true"
            striped
            sort-by="carrier"
            sort-by-formatted
            table-class="word-nowrap"
            :style="{ maxHeight: 'fit-content' }"
        >


          <template #cell(carrier)="data">
            <span v-html="getCarrierNameByID(data.item.carrier)"></span>
          </template>


          <template #cell(ABRLinks)="data">
            <ul v-if="data.item.ABRLinks" class="list-unstyled m-0">
              <template v-for="(abr, i) of data.item.ABRLinks">
                <li v-if="abr.id" :key="i">
                  <b-link @click="showABRModal(abr.id)" target="_blank"><span v-html="abr.title"></span></b-link>
                </li>
              </template>
            </ul>
          </template>

          <template #cell(ProdIssueAge)="data">
            {{ data.item.ProdIssueAgeMin }} - {{data.item.ProdIssueAgeMax}}, {{data.item.ProdIssueAgeType}}
          </template>

          <template #cell(ProdDBOptions)="data">
            <div>
              <ul v-if="data.item.ProdDBOptions" class="list-unstyled m-0">
                <template v-for="(option, i) of data.item.ProdDBOptions">
                  <li v-if="option" :key="i">
                    {{ option }}
                  </li>
                </template>
              </ul>
            </div>
          </template>

          <template #cell(ProdDuration)="data">
            <span >{{data.item.ProdDuration.join(", ")}}</span>
          </template>

          <template #cell(ProdRidersOptions)="data">
            <span >{{data.item.ProdRidersOptions.join(", ")}}</span>
          </template>

          <template #cell(ProdDBMin)="data">
            <span >${{Number(data.item.ProdDBMin).toLocaleString()}}</span>
          </template>

          <template #cell(ProdCapParRates)="data">
            <ul v-if="data.item.ProdCapParRates" class="list-unstyled m-0">
              <template v-for="(link, i) of data.item.ProdCapParRates">
                <li v-if="link.ProdURL.url" :key="i">
                  <b-link :href="link.ProdURL.url" target="_blank">
                    {{ (link.ProdURL.title ? link.ProdURL.title : link.ProdURL.url) }}
                  </b-link>
                </li>
              </template>
            </ul>
          </template>

          <template #cell(ProdInfoLinks)="data">
            <ul v-if="data.item.ProdInfoLinks" class="list-unstyled m-0">
              <template v-for="(link, i) of data.item.ProdInfoLinks">
                <li v-if="link.ProdURL.url" :key="i">
                  <b-link :href="link.ProdURL.url" target="_blank">
                    {{ (link.ProdURL.title ? link.ProdURL.title : link.ProdURL.url) }}
                  </b-link>
                </li>
              </template>
            </ul>
          </template>

        </b-table>
      </div>
    </template>
    <b-modal id="abr_modal" modal-class="carrier-matrix" :title="toText(abrTitle)" centered hide-footer static>
      <ul  class="list-unstyled" v-if="abrContent">
        <template v-for="(field, key) of abrContent">
          <li :key="key" v-if="field !== '' && key !== 'carrier' && key !== 'ProdLinks'">

            <span v-if="key === 'verification_date'"><strong>Verified on:</strong> {{convertDate(field[0])}}</span>

            <span v-else-if="key === 'ABRElimPeriod'">
              <strong>{{ formatABRLabel(key) }}:</strong> {{ field[0] }}
            </span>

            <span v-else-if="key === 'ABRInfoLinks'">

              <strong>Info Links:</strong>

              <ul>
              <template v-for="(link, i) of field">
                <li v-if="link.url.url" :key="i">
                  <b-link :href="link.url.url" target="_blank">
                    {{ (link.url.title ? link.url.title : link.url.url) }}
                  </b-link>
                </li>
              </template>
              </ul>

            </span>

            <span v-else><strong>{{ formatABRLabel(key) }}:</strong> <span v-html="(field === false || field === true ? (field === false ? 'False' : 'True') : field )"></span></span>

          </li>
        </template>
      </ul>
    </b-modal>
  </div>
</template>

<script>
import {bus} from "@/event-bus"
import HelperFunctions from "@/mixins/helper-functions"
import * as XLSX from "sheetjs-style"
export default {
  name: "productResults",
  mixins: [HelperFunctions],
  data: () => ({
    productResultItems: [],
    filteredVisibleFields: [],
    visibleFields: [],
    abrTitle: '',
    abrContent: '',
    csvData: [],
    agencyName: '',
  }),
  mounted() {
    bus.$on("update-product-results-items", items => {
      this.productResultItems = []
      this.productResultItems = items
      this.$nextTick(this.syncScroll);
    })
    bus.$on("update-product-visible-fields", fields => {
      this.visibleFields = fields
      
      // Add dynamic styling for column widths
      if (this.productResultItems.length > 0 && this.productResultItems[0]._column_widths) {
        
        this.visibleFields.forEach(field => {
          // Find the first item that has width information for this field
          const firstItem = this.productResultItems.find(item => 
            item._column_widths && item._column_widths[field.key]
          );
          
          if (firstItem && firstItem._column_widths[field.key]) {
            const width = firstItem._column_widths[field.key];
            field.tdClass = `column-width`;
            field.thClass = `column-width`;
            field.thStyle = { width: `${width}px`, minWidth: `${width}px` };
            field.tdStyle = { width: `${width}px`, minWidth: `${width}px` };
          }
        });
      }
      
      this.$nextTick(() => {
        this.syncScroll();
      });
    })
    bus.$on("update-carriers", carriers => {
      this.carriers = []
      this.carriers = carriers
    })
    bus.$on("update-agency-name", agencyName => {
      this.agencyName = agencyName
    })
    
    this.setupDynamicColumnWidths();
  },
  methods: {
    setupDynamicColumnWidths() {
      // Handle any dynamic column width adjustments
      window.addEventListener('resize', () => {
        this.$nextTick(this.syncScroll);
      });
    },
    showABRModal(id) {
      fetch(this.$hostname + '/cm_api/wp/v2/abr/' + id)
          .then(response => response.json())
          .then(data => {
            this.abrTitle = (data.title ? data.title.rendered : '')
            this.abrContent = data.custom
            this.$root.$emit('bv::show::modal', 'abr_modal')
          })
    },
    formatABRLabel(label) {
      return label.replace('ABR', '').replace(/[A-Z]/g, ' $&')
    },
    syncScroll() {
      const headerTable = document.querySelector(".results-table.header-only");
      const contentTable = document.querySelector(".results-table.content-only");

      if (headerTable && contentTable) {
        const syncScrollHandler = (source, target) => {
          source.addEventListener("scroll", () => {
            target.scrollLeft = source.scrollLeft;
          });
        };

        syncScrollHandler(headerTable, contentTable);
        syncScrollHandler(contentTable, headerTable);
      } else {
        console.warn("Header or Content table not found!");
      }
    },
    onHeaderClicked(field) {
      if (!field) {
        console.warn('Invalid field:', field);
        return;
      }

      const headerCells = document.querySelectorAll(
        ".results-table.header-only th div"
      );
      const contentCells = document.querySelectorAll(
        ".results-table.content-only th div"
      );

      if (headerCells.length !== contentCells.length) {
        console.warn("Header and content table columns mismatch!");
        return;
      }

      const clickedIndex = Array.from(headerCells).findIndex((div) => {
        const divText = (div.textContent || "").trim().toLowerCase();
        return divText === field.toLowerCase();
      });

      if (clickedIndex !== -1) {
        const targetCell = contentCells[clickedIndex];

        const syncSort = () => {
          const targetSort = targetCell.parentElement.getAttribute("aria-sort");
          const headerSort = headerCells[clickedIndex].parentElement.getAttribute("aria-sort");
          if (targetSort === headerSort) {
            targetCell.click();
          }
        };
        syncSort();
      } else {
        console.warn(`No matching header found for field: ${field}`);
      }
    },
    exportToExcel(items, fields, title) {
      // Filter out link-related fields
      // Filter out link-related fields, except for ABRLinks
      const filteredFields = fields.filter(field => 
        field.key === "ABRLinks" || // Keep ABRLinks
        (!field.key.includes('Links') && !field.label.toLowerCase().includes('links'))
      );

      // Map fields and items into Excel-compatible data
      const data = items.map((item) => {
        const row = {};
        filteredFields.forEach((field) => {
          let value;
          try {
            if (field.key === "carrier") {
              value = this.getCarrierNameByID(item.carrier);
            } else if (field.key === "ProdIssueAge") {
              value = `${item.ProdIssueAgeMin} - ${item.ProdIssueAgeMax}, ${item.ProdIssueAgeType}`;
            } else if (field.key === "ProdDBOptions" || field.key === "ProdRidersOptions") {
              value = Array.isArray(item[field.key]) ? item[field.key].join(", ") : "";
            } else if (field.key === "ProdDuration") {
              value = Array.isArray(item[field.key]) ? item[field.key].join(", ") : "";
            } else if (field.key === "ProdDBMin") {
              value = item[field.key] ? `$${Number(item[field.key]).toLocaleString()}` : "";
            } else if (typeof item[field.key] === 'boolean') {
              value = item[field.key] ? "Yes" : "No";
            } else if (Array.isArray(item[field.key])) {
              // Special handling for arrays
              if (item[field.key].every(i => typeof i === 'string')) {
                value = item[field.key].join(", ");
              } else {
                // Try to extract meaningful information from array of objects
                const extractedValues = item[field.key].map(obj => {
                  if (typeof obj === 'object' && obj !== null) {
                    // Try common properties that might contain text
                    if (obj.text) return obj.text;
                    if (obj.title) return obj.title;
                    if (obj.name) return obj.name;
                    if (obj.label) return obj.label;
                    if (obj.value) return obj.value;
                    
                    // For URL objects
                    if (obj.url) {
                      if (typeof obj.url === 'object') {
                        return obj.url.title || obj.url.url || '';
                      }
                      return obj.url;
                    }
                    
                    // For ProdURL objects (common in product search)
                    if (obj.ProdURL) {
                      if (typeof obj.ProdURL === 'object') {
                        return obj.ProdURL.title || obj.ProdURL.url || '';
                      }
                      return obj.ProdURL;
                    }
                    
                    // If we can't find a meaningful property, try to stringify
                    const keys = Object.keys(obj);
                    if (keys.length > 0) {
                      return keys.map(key => {
                        const val = obj[key];
                        if (typeof val !== 'object' || val === null) {
                          return val;
                        }
                        return '';
                      }).filter(Boolean).join(", ");
                    }
                  }
                  return String(obj);
                });
                
                value = extractedValues.filter(Boolean).join(", ");
              }
            } else if (typeof item[field.key] === 'object' && item[field.key] !== null) {
              // Special handling for objects
              const obj = item[field.key];
              
              // Try common properties that might contain text
              if (obj.text) value = obj.text;
              else if (obj.title) value = obj.title;
              else if (obj.name) value = obj.name;
              else if (obj.label) value = obj.label;
              else if (obj.value) value = obj.value;
              // For URL objects
              else if (obj.url) {
                if (typeof obj.url === 'object') {
                  value = obj.url.title || obj.url.url || '';
                } else {
                  value = obj.url;
                }
              }
              // For ProdURL objects (common in product search)
              else if (obj.ProdURL) {
                if (typeof obj.ProdURL === 'object') {
                  value = obj.ProdURL.title || obj.ProdURL.url || '';
                } else {
                  value = obj.ProdURL;
                }
              }
              // If we can't find a meaningful property, try to extract key/value pairs
              else {
                const parts = [];
                for (const key in obj) {
                  if (typeof obj[key] !== 'object' || obj[key] === null) {
                    parts.push(`${key}: ${obj[key]}`);
                  }
                }
                value = parts.join(", ");
              }
            } else {
              value = item[field.key] || "";
            }
            
            // Process content for hyperlinks
            const processedContent = this.cleanCellContent(value, true);
            row[field.label] = processedContent.text;
            
            // Store link information if any
            if (processedContent.links && processedContent.links.length > 0) {
              if (!row._hyperlinks) row._hyperlinks = {};
              row._hyperlinks[field.label] = processedContent.links;
            }
          } catch (error) {
            console.error(`Error processing field ${field.key}:`, error);
            row[field.label] = String(item[field.key] || "");
          }
        });
        return row;
      });
      
      // Sort data by carrier (A-Z)
      const sortedData = data.sort((a, b) => {
        const carrierA = a['Carrier'] || '';
        const carrierB = b['Carrier'] || '';
        return carrierA.localeCompare(carrierB);
      });

      // Create a worksheet
      const worksheet = XLSX.utils.book_new();

      // Calculate total columns for merging
      const totalColumns = filteredFields.length;

      // Add title row
      worksheet["A1"] = { t: "s", v: title };
      worksheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: totalColumns - 1 } }];

      // Add headers in second row
      const headerRow = filteredFields.map(field => field.label);
      XLSX.utils.sheet_add_aoa(worksheet, [headerRow], { origin: "A2" });

      // Add data starting from third row
      XLSX.utils.sheet_add_json(worksheet, sortedData, { origin: "A3", skipHeader: true });

      // Add hyperlinks
      sortedData.forEach((row, rowIndex) => {
        if (row._hyperlinks) {
          Object.entries(row._hyperlinks).forEach(([colName, links]) => {
            const colIndex = headerRow.indexOf(colName);
            if (colIndex !== -1 && links.length > 0) {
              const cellRef = XLSX.utils.encode_cell({ r: rowIndex + 2, c: colIndex }); // +2 for title and header rows
              worksheet[cellRef].l = { Target: links[0].url, Tooltip: links[0].text };
            }
          });
        }
      });

      // Styling for the title row
      worksheet["A1"].s = {
        font: { name: "Arial", bold: true, sz: 24, color: { rgb: "0076BD" } },
        alignment: { horizontal: "center", vertical: "center" },
      };

      // Apply styles to header row
      headerRow.forEach((_, index) => {
        const cell = XLSX.utils.encode_cell({ r: 1, c: index }); // A2, B2, etc.
        if (!worksheet[cell]) {
          worksheet[cell] = { t: 's', v: headerRow[index] };
        }
        worksheet[cell].s = {
          font: { name: "Arial", bold: true, sz: 11, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "center", vertical: "bottom", wrapText: true },
          fill: { fgColor: { rgb: "0076BD" } },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      });

      // Apply styles to data rows
      Object.keys(worksheet).forEach((cell) => {
        if (cell[0] === '!') return;

        const { r } = XLSX.utils.decode_cell(cell);

        if (r === 0 || r === 1) {
          return;
        }

        const isEvenRow = r % 2 === 0;

        if (!worksheet[cell]) {
          worksheet[cell] = { t: 's', v: '' };
        }
        worksheet[cell].s = {
          font: { name: "Arial", sz: 11, color: { rgb: "6E6F71" } },
          alignment: { horizontal: "left", vertical: "top", wrapText: true },
          fill: { fgColor: { rgb: isEvenRow ? "FFFFFF" : "E7E7E7" } },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      });

      // Set column widths (dynamic: 28 if long text, 14 otherwise)
      const columnWidths = filteredFields.map((field, columnIndex) => {
        // Get the column width from the _column_widths property of the first item
        let width = 14; // Default width
        
        // Check if we have items with _column_widths
        if (items.length > 0 && items[0]._column_widths && items[0]._column_widths[field.key]) {
          // Convert the width from pixels to Excel column width units (approximately)
          // Excel column width is in characters, roughly 7 pixels per character
          width = Math.round(items[0]._column_widths[field.key] / 7);
        } else {
          // Fallback to dynamic width based on content
          const columnData = [headerRow[columnIndex], ...sortedData.map(row => Object.values(row)[columnIndex])];
          const hasLongText = columnData.some(cell => (cell || "").toString().length > 90);
          width = hasLongText ? 28 : 14;
        }
        
        return { wch: width };
      });

      worksheet["!cols"] = columnWidths;

      // Fetch and clean Terms of Use text
      const termsOfUse = document.querySelector(".cm-terms-of-use")?.innerText || "";
      const cleanedTermsOfUse = this.cleanCellContent(termsOfUse);

      // Add Terms of Use to the last row
      const lastRow = data.length + 2; // +2 to account for title and header rows
      worksheet[XLSX.utils.encode_cell({ r: lastRow, c: 0 })] = { t: "s", v: cleanedTermsOfUse };

      // Apply styling to each cell in the Terms of Use row first
      for (let i = 0; i < totalColumns; i++) {
        const cellRef = XLSX.utils.encode_cell({ r: lastRow, c: i });
        if (i > 0) {
          // Create empty cells for columns 1 to totalColumns-1
          worksheet[cellRef] = { t: "s", v: "" };
        }
        
        // Apply borders to all cells in the row
        worksheet[cellRef].s = {
          font: { name: "Arial", sz: 11, color: { rgb: "6E6F71" } },
          alignment: { horizontal: "left", vertical: "center", wrapText: true },
          fill: { fgColor: { rgb: "FFFFFF" } },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }

      // Merge the Terms of Use row after styling all cells
      worksheet["!merges"].push({ s: { r: lastRow, c: 0 }, e: { r: lastRow, c: totalColumns - 1 } });

      // Set row height for the Terms of Use row
      if (!worksheet["!rows"]) worksheet["!rows"] = [];
      worksheet["!rows"][lastRow] = { hpt: 50 }; // Height in points (50)

      // Update the worksheet range (!ref) to include the last row
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      range.e.r = lastRow;
      worksheet["!ref"] = XLSX.utils.encode_range(range);

      // Create a workbook and add the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Product Results");

      // Export the workbook
      XLSX.writeFile(workbook, `${title}.xlsx`);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.results-table {
  overflow-x: auto;
  width: 100%;
}

.results-table.header-only {
  margin-bottom: 0;
  overflow-y: hidden;
}

.results-table.header-only thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.results-table.header-only tbody {
  visibility: collapse;
  line-height: 0;
}

.results-table.content-only thead {
  visibility: collapse;
  line-height: 0;
}

.width-126 {
  width: 126px;
  min-width: 126px;
}

.column-width {
  /* Default width if not specified by API */
  width: 280px;
  min-width: 280px;
}
</style>
<style>
.results-table {
  width: 100%;
}

.results-table.header-only thead {
    background-color: white;
}

.results-table.header-only {
    position: sticky;
    top: 0px;
    z-index: 10;
}

.results-table.header-only,
.results-table.header-only table {
  margin: 0 !important;
}

.results-table.header-only tbody {
  visibility: collapse; /* Hide the body of the header table */
}

.results-table.content-only thead {
  visibility: collapse; /* Hide the header of the content table */
}

.results-table {
  overflow: auto;
}

.results-table table {
  margin-bottom: 0px !important;
}

/* Sticky first column */
.results-table th:first-child,
.results-table td:first-child {
  position: sticky;
  left: 0;
  z-index: 3;
  border-right: none !important; /* Remove the border as we'll use pseudo-element */
  box-shadow: none !important; /* Remove the shadow as we'll use pseudo-element */
}

/* Create a pseudo-element for the right border of the first column */
.results-table th:first-child::after,
.results-table td:first-child::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 1px;
  background-color: #dee2e6;
  z-index: 5;
}

.results-table.header-only th:first-child::after {
  left: 100% !important;
}

.results-table th:first-child::before,
.results-table td:first-child::before {
  content: "";
  position: absolute;
  top: 0;
  left: -1px;
  bottom: 0;
  width: 1px;
  background-color: #dee2e6;
  z-index: 5;
}

.results-table th:first-child {
  z-index: 4;
  border-right: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  box-shadow: none !important;
}

/* Override Bootstrap's border styling explicitly */
.results-table.bordered th:first-child,
.results-table.bordered td:first-child {
  border-right: none !important;
}

/* Add white background to all header cells */
.results-table thead th {
  background-color: white !important;
  border-bottom: 2px solid #dee2e6 !important;
  box-shadow: none !important;
}

/* Create a pseudo-element for the bottom border of the header */
.results-table thead th::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #dee2e6;
  z-index: 5;
}

/* Background colors for all rows */
.results-table tbody tr:nth-child(odd),
.results-table tr.b-table-row-odd,
.results-table tbody tr:nth-child(odd) td:first-child {
  background-color: white !important;
}

.results-table tbody tr:nth-child(even),
.results-table tr.b-table-row-even,
.results-table tbody tr:nth-child(even) td:first-child {
  background-color: #f2f2f2 !important;
}

table th {
  padding-top: 1.6rem !important;
}
</style>
